import { useState } from 'react';

export const useStringArrayTracking = () => {
  const [stringArr, setStringArr] = useState<string[]>([]);
  function addStrings(newStrings: string[]) {
    setStringArr((currentStrings) => [...currentStrings, ...newStrings]);
  }

  function removeStrings(removedStrings: string[]) {
    setStringArr((currentStrings) =>
      currentStrings.filter((currentString) => !removedStrings.includes(currentString)),
    );
  }
  return {
    addStrings,
    removeStrings,
    stringArr,
  };
};
